import { Tab as MuiTab, Tabs as MuiTabs, TabProps } from "@mui/material";
import { withStyles } from "@mui/styles";

import { colors } from "theme";

export const Tabs = withStyles({
  root: {
    borderTop: `1px solid ${colors.grey[500]}`,
    borderBottom: `1px solid ${colors.grey[500]}`,
    minHeight: "auto",
  },
  indicator: {
    height: 4,
  },
})(MuiTabs);

export const Tab = withStyles(() => ({
  root: {
    padding: "17.5px 30px",
    background: "white",
    letterSpacing: 0.5,
    lineHeight: "18px",
    fontWeight: 600,
    opacity: 1,
    minWidth: "auto",
    minHeight: "auto",
    textTransform: "initial",
    "&:hover": {
      background: colors.grey[500],
      color: colors.violet[900],
    },
  },
  wrapper: {},
  selected: {},
}))((props: TabProps) => <MuiTab disableRipple {...props} />);
